const content: { [key: string]: any } = {
  pageTitle: "Strong Start Incentive+",
  bannerTile: {
    earning: "Great Job! You are earning the Strong Start Incentive+.",
    tracking: "Keep going to earn the Strong Start Incentive+!",
    notTracking: "It is no longer possible for you to achieve the Strong Start Incentive+.",
    notEligible: "You are not eligible for the Strong Start Incentive+ for {month} {year}.",
    manuallyApproved: "The Strong Start Incentive+ has been manually approved.",
    missedWindow: "It is no longer possible for you to achieve the Strong Start Incentive+ in {month} {year}.",
    held: "Your award is on hold.",
    youreEligibleToEarnThisIncentiveTimes:
      "You're eligible to earn this incentive <1>{times} more times</1> until {month} {year}.",
    descriptionStart:
      "This incentive must be started during your registration month or the two months following and then must be consecutively achieved <1>every</1> month for up to 12 months.",
    descriptionOnePayment:
      "You need to meet these monthly requirements for the next <1>{numMonths}</1> months consecutively to earn the next payment of <2>{payment}</2>.",
    descriptionTwoPayments:
      "You're eligible to earn this incentive <1>{times} more times</1> until {month} {year}. There is an opportunity to achieve <2>{paymentOne}</2> and <3>{paymentTwo}</3> if you meet these monthly requirements for {numMonthsOne} and {numMonthsTwo} months.",
    descriptionTwoPaymentsOnePaymentRemaining:
      "You're eligible to earn this incentive <1>{times} more times</1> until {month} {year}. There is an opportunity to achieve <2>{paymentOne}</2> if you meet these monthly requirements for {numMonthsOne} months.",
    descriptionThreePaymentsRemaining:
      "You're eligible to earn this incentive <1>{times} more times</1> until {month} {year}. There is an opportunity to achieve <2>{paymentOne}</2>, <3>{paymentTwo}</3>, and <4>{paymentThree}</4> if you meet these monthly requirements for {numMonthsOne}, {numMonthsTwo}, and {numMonthsThree} months.",
    moreInformation: "If you require more information, please contact Customer Support for further details.",
    learnMore: "Learn More",
    strongStartIncentiveEarnings: "Strong Start Incentive+ Earnings",
    comingSoon: "Happy New Performance Year!",
    comingSoonDescription:
      "We are upgrading the SSI tracking screen for PY 2025–26. Your SSI qualifications are already being calculated in the system and will reflect as soon as program updates are complete. Thank you for your patience as we enhance the experience.",
    gracePeriodOnePaymentDescription:
      "You are able to miss the requirements one month within your qualification period. You're still eligible to earn this incentive <1>{times} more time</1> until {month} {year}. There is an opportunity to achieve <2>{payment}</2> if you meet these monthly requirements for {numMonths} months.",
    gracePeriodTwoPaymentDescription:
      "You are able to miss the requirements one month within your qualification period. You're still eligible to earn this incentive <1>{times} more times</1> until {month} {year}. There is an opportunity to achieve <2>{paymentOne}</2> and <3>{paymentTwo}</3> if you meet these monthly requirements for {numMonthsOne} and {numMonthsTwo} months.",
  },
  progressTile: {
    title: "Track your progress",
    requirementLabel: "You've met <1>{current} of {needed}</1> requirements to earn this incentive.",
    eligibilityWindowDetails: "Eligibility Window Details",
    met: "SSI Requirement {number} Met",
    notMet: "Tracking SSI Requirement {number}",
  },
  requirements: {
    sectionHeader: "How do I qualify? Here is the list of requirements.",
    personal: {
      title: "{volume} PPV",
      description: "",
      tooltip:
        '"Personal PV" is the PV that comes from an ABO\'s personal orders and any orders from their personal customers. Downline ABO purchases do not count towards your Personal PV, downline PV is added to your Personal PV and is called "Group PV."',
    },
    member: {
      title: "{volume} PCPV",
      description: "",
    },
    vcs: {
      title: "{volume} VCS PV",
      description: "",
    },
  },
  eligibilityModal: {
    title: "Eligibility",
    subtitle: "Program Details",
    eligibilityDescriptionSecondFullMonth:
      "<1>You must achieve the 2nd full month after your registration month</1> in order to continue in the Strong Start Incentive+.",
    eligibilityDescriptionEveryMonth:
      "You must achieve the requirements <1>every month</1> in order to continue in the Strong Start Incentive+.",
    entryDate: "Entry Date",
    startDate: "Start Date",
    endDate: "End Date",
    programDescription:
      "The Strong Start Incentive+ rewards behaviors for achieving baseline requirements month after month. Earn rewards after <1>{initialPayDayMonths}</1> and <2>{finalPayDayMonth}</2> months of achievement.",
    moreInformation:
      "For detailed information about eligibility, refer to <1>Amway.com/en_US/money-and-rewards</1> for complete details.",
  },
  v2: {
    vcsPV: {
      title: "{target} VCS PV",
      progressLabel: "Target: {target}",
    },
    howDoYouQualify: {
      title: "How do you qualify?",
      description:
        "This incentive must be started during your registration month or the two months following and then must be consecutively achieved every month for up to 12 months by achieving {maintainTarget} VCS PV each month. Depending on your monthly Performance Bonus Level, you can earn {belowAmount} if you are below {belowPercent}, {equalAmount} if you are at {equalPercent}, and {aboveAmount} if you are at {abovePercent} or above. Incentives are paid quarterly, with up to four quarterly payments available, provided you meet the {maintainTarget} VCS PV monthly requirement throughout the qualification period.",
    },
    performanceBonusProgress: {
      title: "Performance Bonus Progress",
      subtitleLabel: "GPV Needed to Reach {percent}:",
      totalGPV: "Total GPV",
      performanceBonusLevel: "Performance Bonus Level",
      target: "{amount} Target",
    },
    qualificationProgress: {
      title: "Qualification Progress",
      entryDateLabel: "Entry Date:",
      startDateLabel: "Start Date:",
      endDateLabel: "End Date:",
      paymentsToDateLabel: "Strong Start Incentive+ Payments to Date:",
      paymentsToDateValue: "{paidCount} of {totalPaymentCount}",
      totalEarnedLabel: "Total Earned YTD:",
      gracePeriodDescriptionBold: "You must achieve the 3rd full month after your registration month",
      gracePeriodDescriptionRegular: "in order to continue in the Strong Start Incentive+.",
      firstPayment: "First Potential Payment",
      secondPayment: "Second Potential Payment",
      thirdPayment: "Third Potential Payment",
      fourthPayment: "Fourth Potential Payment",
      firstPaymentCompleted: "First Payment",
      secondPaymentCompleted: "Second Payment",
      thirdPaymentCompleted: "Third Payment",
      fourthPaymentCompleted: "Fourth Payment",
      legend: {
        potential: "Potential",
        qualified: "Qualified",
        notQualified: "Not Qualified",
        unavailable: "Unavailable",
      },
    },
    achieved: "Achieved",
  },
} as const;

export default content;
